<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerInvestmentPresenter } from '../composables/realEstateBrokerInvestmentPresenter';

defineProps({
  suggestions: { type: Array, default: () => [] },
});

const { t } = useI18n();
const { address, addressDetail, money } =
  createRealEstateBrokerInvestmentPresenter(t);
</script>

<template>
  <LaisCard density="tight">
    <div class="p-5 sm:p-6">
      <h2 class="text-lg font-bold text-lais-text">
        {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.SUGGESTIONS_TITLE') }}
      </h2>
      <div
        v-if="suggestions.length"
        class="mt-4 divide-y divide-lais-border-soft"
      >
        <article
          v-for="suggestion in suggestions"
          :key="suggestion.imovel_id"
          class="flex flex-wrap items-center justify-between gap-3 py-4 first:pt-0 last:pb-0"
        >
          <div>
            <p class="font-semibold text-lais-text">
              {{ address(suggestion) }}
            </p>
            <p class="text-xs text-lais-text-muted">
              {{
                addressDetail(suggestion) ||
                t('REAL_ESTATE_BROKER_INVESTMENT.TABLE.NOT_INFORMED')
              }}
            </p>
          </div>
          <p class="font-semibold text-lais-text">
            {{ money(suggestion.valor_venda) }}
          </p>
        </article>
      </div>
      <p v-else class="mt-4 text-sm text-lais-text-muted">
        {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.SUGGESTIONS_EMPTY') }}
      </p>
    </div>
  </LaisCard>
</template>
